<div class="container mx-auto flex items-center min-h-screen px-6 py-12 mx-auto">
    <main class="mx-auto flex w-full max-w-7xl flex-auto flex-col justify-center px-6 py-24 sm:py-64 lg:px-8">
        <p class="text-base font-semibold leading-8 text-voyse">404</p>
        <h1 class="mt-4 text-3xl font-bold tracking-tight text-gray-900 sm:text-5xl">Page not found</h1>
        <p class="mt-6 text-base leading-7 text-gray-600">Sorry, we couldn’t find the page you’re looking for.</p>
        <div class="mt-10">
            <button
                [routerLink]="['/']"
                class="w-1/2 px-5 py-2 text-sm tracking-wide text-white transition-colors duration-200 bg-voyse rounded-lg shrink-0 sm:w-auto hover:bg-voyse/70">
                <span aria-hidden="true">&larr;</span> Take me home
            </button>
        </div>
    </main>
</div>
